import { Injectable } from "@angular/core";
import { ApiService, UserModel } from "@bt/core";
import { IResponse } from "@bt/shared";
import { ExchangeInfo } from "../models/ExchangeInfo.model";
import { ExchangeAvailableCoin } from "../models/ExchangeAvailableCoin.model";
import { CoinPurchaseHistory } from "@bt/auto-coin-purchase/models/CoinPurchaseHistory.model";

/**
 * Позволяет загружать инфрмацию, необходимую для настройки
 * автоматической закупки криптомонет
 */
@Injectable()
export class CoinPurchaseInfoService {
  /**
   * Корневой api-адрес сервиса
   * @private
   */
  private readonly apiUri: string = "api/coin-purchase";

  constructor(private api: ApiService) {
  }

  /**
   * Возвращает список поддерживаемых криптобирж
   */
  public getExchanges(): Promise<IResponse<ExchangeInfo[]>> {
    return this.api.get<ExchangeInfo[]>(
        this.buildApiUri("getExchanges"))
      .toPromise();
  }

  /**
   * Возвращает список доступных для закупки монет у указанной криптобиржи
   * @param exchangeId Идентификатор криптобиржи
   */
  public getAvailableCoins(
    exchangeId: number,
  ): Promise<IResponse<ExchangeAvailableCoin[]>> {
    return this.api.get<ExchangeAvailableCoin[]>(
        this.buildApiUri("getAvailableCoins"),
        { "exchangeId": `${exchangeId}` })
      .toPromise();
  }

  /**
   * Возвращает историю покупки монет
   */
  public getCoinPurchaseHistory() {
    return this.api.get<CoinPurchaseHistory[]>(
        this.buildApiUri("getCoinPurchaseHistory"))
      .toPromise();
  }

  /**
   * Возвращает список пользователей
   */
  public getUserList(): Promise<IResponse<UserModel[]>> {
    return this.api.get<UserModel[]>(
        this.buildApiUri("getUsersForWithdraw"))
      .toPromise();
  }

  /**
   * Формирует ссылку для запроса
   * @param uriString Команда api-запроса
   */
  private buildApiUri(uriString: string): string {
    if (!uriString.startsWith("/"))
      uriString = "/" + uriString;

    return this.apiUri + uriString;
  }
}



// WEBPACK FOOTER //
// ./src/app/auto-coin-purchase/services/coinPurchaseInfo.service.ts